import { memo } from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MfaForm from 'modules/security_settings/pages/SecuritySettingsPage/AuthSection/mfaForm'

import { TypedSecuritySettingsAuthSectionFragment } from './types'

function AuthSection({ mfaStatus }: TypedSecuritySettingsAuthSectionFragment) {
  return (
    <Section.TwoThirds
      title={i18n.t('security_settings.auth.title')}
      description={i18n.t('security_settings.auth.description')}
    >
      <MfaForm mfaStatus={mfaStatus} />
    </Section.TwoThirds>
  )
}

export default memo(AuthSection)
